// runtime can't be in strict mode because a global variable is assign and maybe created.
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[275],{

/***/ 49389:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "CT": function() { return /* binding */ API_BASE_URL; },
/* harmony export */   "J7": function() { return /* binding */ ABOVE_THE_FOLD_OPTIMIZATION_LOCATION_NAME; },
/* harmony export */   "LJ": function() { return /* binding */ clientIds; },
/* harmony export */   "MF": function() { return /* binding */ CHANNEL_IDS; },
/* harmony export */   "Mu": function() { return /* binding */ PREVIEW_REGEXP; },
/* harmony export */   "Ul": function() { return /* binding */ COLLECTIONS; },
/* harmony export */   "aU": function() { return /* binding */ BRAND_NAMES; },
/* harmony export */   "bx": function() { return /* binding */ MEASUREMENT_TYPE; },
/* harmony export */   "cH": function() { return /* binding */ NIKE_SHOP_ELEMENT_ID; },
/* harmony export */   "cd": function() { return /* binding */ ADOBE_TARGET_COOKIE_NAME; },
/* harmony export */   "dH": function() { return /* binding */ MEASUREMENTS_UNITS; },
/* harmony export */   "gm": function() { return /* binding */ NIKE_BASE_URL; },
/* harmony export */   "nM": function() { return /* binding */ segmentProdKey; },
/* harmony export */   "qp": function() { return /* binding */ BRANDS; },
/* harmony export */   "sL": function() { return /* binding */ PAGE_TYPES; },
/* harmony export */   "uB": function() { return /* binding */ ROOT_ELEMENT_ID; },
/* harmony export */   "vC": function() { return /* binding */ DEFAULT_OPTIMIZATION_LOCATION_NAME; },
/* harmony export */   "y8": function() { return /* binding */ FEATURE_FLAGS; },
/* harmony export */   "zX": function() { return /* binding */ segmentTestKey; },
/* harmony export */   "zr": function() { return /* binding */ DEFAULT_IMPERIAL_MARKETPLACES; }
/* harmony export */ });
/* unused harmony exports UTILITY_FLAGS, APPS_SMART_BANNER_ID */
const BRAND_NAMES = {
  JORDAN: 'jordan',
  NIKE: 'nike',
  NIKE_JOURNAL: 'nikeJournal',
};

const PAGE_TYPES = {
  ARTICLE: 'article',
  PAGE: 'page',
  SIZE_CHART: 'size_chart',
};

/**
 * Map of the supported flags
 */
const FEATURE_FLAGS = {
  DISABLE_ANALYTICS_CLIENT: 'x-disable-analytics-client',
  DISABLE_APPS_FLYER: 'x-disable-appsflyer',
  DISABLE_GLOBAL_NAV: 'x-disable-global-nav',
  DISABLE_MC: 'x-disable-mc',
  DISABLE_SHOP_CART: 'x-disable-shop-cart',
  DISABLE_UI_EXPERIMENTS: 'x-disable-ui-experiments',
  DISABLE_UNITE: 'x-disable-unite',
  ENABLE_CONSOLE_LOGGING: 'x-enable-console-logging',
  WITH_MOCKS: 'clp-with-mocks',
};
/**
 * Map of the supported utility flags
 */
const UTILITY_FLAGS = {
  FORCED_VARIATIONS: 'forcedVariations', // to be used by optimizely
  NIKE_ENV: 'nikeEnv',
  PREVIEW_VARIANT_ID: 'variationId',
  TS: 'ts',
};

const NIKE_BASE_URL = `https://${"www.nike.com.cn"}`;
const API_BASE_URL = `https://${"api.nike.com.cn"}`;

const APPS_SMART_BANNER_ID = '_td_smartbanner_js'; // smart-banner ID should be a fixed value, never change it

const CHANNEL_IDS = {
  BANNER: '8fac54d0-ed4f-4cf5-b829-e04d3d6008f8',
  DEFAULT: 'd9a5bc42-4b9c-4976-858a-f159cf99c647',
  SNKRS: '010794e5-35fe-4e32-aaff-cd2c74f89d61',
};

const COLLECTIONS = {
  howTo: {
    collectionId: 'fe94947a-f05b-4a2b-a438-e4ddf24477eb',
  },
  nikeJournal: {
    collectionId: 'a169eb4b-d643-419b-aa03-988d18535d25',
    taxonomyTag: '36d163a1-fa45-45c0-bfbb-3d174015d851',
  },
  sizeCharts: {
    collectionId: '32c0681c-e627-4f6d-9390-ce83e7fba02c',
  },
};

const segmentProdKey = '2iv4Qa7rFEipAs4iE850BkBpTYQvlAFZ';
const segmentTestKey = 'eh46CSMEgCao5Y3uW7Jh1bBTAA34vEfU';

// (\/[a-z]{2})? - part for checking of location and lang
const PREVIEW_REGEXP = /^(\/[a-z]{2})?(\/[a-z]{2})?(\/clp)?\/thread/i;

const clientIds = {
  homepage: 'nike:dotcom.browse.homepage:client:1.0',
  landingpage: 'nike:dotcom.browse.landingpage:client:1.0',
  product_recommender: 'com.nike.commerce.nikedotcom.web',
};

const BRANDS = {
  [BRAND_NAMES.JORDAN]: {
    collectionId: '4b69f63c5e87c687f251bdea1f82121b32018ae5',
  },
};

// id of node that mounts react app
const ROOT_ELEMENT_ID = 'ciclp-app';
const NIKE_SHOP_ELEMENT_ID = 'nike-shop-root';
const ADOBE_TARGET_COOKIE_NAME = 'at_lp_exp';
const DEFAULT_OPTIMIZATION_LOCATION_NAME = 'landingpage_layout';
const ABOVE_THE_FOLD_OPTIMIZATION_LOCATION_NAME =
  'landingpage_abovethefoldLayout';

// Measurement-related constants extracted here from Redux app to enable Bra Size Finder bundle splitting
const MEASUREMENT_TYPE = 'IMPERIAL/METRIC';
const MEASUREMENTS_UNITS = {
  IMPERIAL: 'IMPERIAL',
  METRIC: 'METRIC',
};

const DEFAULT_IMPERIAL_MARKETPLACES = ['US', 'GB', 'CA'];


/***/ }),

/***/ 20427:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "handleDocumentLoad": function() { return /* binding */ handleDocumentLoad; }
});

// EXTERNAL MODULE: ../ciclp-config/lib/constants.js
var constants = __webpack_require__(49389);
// EXTERNAL MODULE: ../ciclp-react-components/src/components/cloudinaryImage/helpers.js
var helpers = __webpack_require__(8552);
// EXTERNAL MODULE: ../ciclp-react-components/src/context/utils.js
var utils = __webpack_require__(53788);
;// CONCATENATED MODULE: ./lcp-image-loader/helpers.js
// importing directly from helpers for better tree shaking


var performImageLoading = function(element) {
    var ref, ref1;
    var img = (0,helpers/* getMediaFromRef */.eI)(element);
    if (!img) {
        return;
    }
    img.dataset.lcpLoaded = true;
    img.src = (0,helpers/* getUrl */.Gr)((ref = img.dataset) === null || ref === void 0 ? void 0 : ref.portraitUrl, (ref1 = img.dataset) === null || ref1 === void 0 ? void 0 : ref1.landscapeUrl, element.clientWidth, element.clientHeight, (0,utils/* isPortraitView */.x4)());
    img.onload = function() {
        img.classList.add(img.dataset.imageLoadedClass);
    };
};
var isInViewport = function(element) {
    var rect = element.getBoundingClientRect();
    return rect.width > 0 && rect.height > 0 && rect.top >= 0 && rect.left >= 0 && rect.bottom <= (window.innerHeight || document.documentElement.clientHeight) && rect.right <= (window.innerWidth || document.documentElement.clientWidth);
};

;// CONCATENATED MODULE: ./lcp-image-loader/lcp-image-loader.js


var handleDocumentLoad = function() {
    Array.from(document.querySelectorAll("#".concat(constants/* ROOT_ELEMENT_ID */.uB, ' [data-container-type="image"] [data-qa="image-wrapper"]'))).filter(isInViewport).forEach(performImageLoading);
};
document.addEventListener("DOMContentLoaded", handleDocumentLoad);


/***/ }),

/***/ 8552:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Gr": function() { return /* binding */ getUrl; },
/* harmony export */   "eI": function() { return /* binding */ getMediaFromRef; },
/* harmony export */   "sG": function() { return /* binding */ getResolvedImgUrl; }
/* harmony export */ });
/* unused harmony exports getDPR, setDPR, setSize, shouldImageBeLoaded */
function getDPR() {
    var ref;
    return (ref = window.devicePixelRatio.toFixed(1)) !== null && ref !== void 0 ? ref : "1";
}
function setDPR(dpr) {
    var url = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "";
    var searchTerm = "f_auto";
    if (url.includes(searchTerm)) {
        var urlSplit = url.split(searchTerm);
        return "".concat(urlSplit[0]).concat(searchTerm, "/dpr_").concat(dpr).concat(urlSplit[1]);
    }
    return url;
}
// Set dimension specified of image to size (px)
function setSize(url, measurement, dimension) {
    if (!url) {
        return "";
    }
    var startIndex = url.indexOf("w_");
    var endIndex = url.indexOf(",", startIndex);
    var originalWidth = url.slice(startIndex, endIndex);
    var urlSplit = url.split(originalWidth);
    return "".concat(urlSplit[0]).concat(dimension, "_").concat(measurement).concat(urlSplit[1]);
}
function getUrl(portraitURL, landscapeURL, width, height, isPortrait) {
    var dimension = "w";
    var measurement = width;
    if (height >= width) {
        dimension = "h";
        measurement = height;
    }
    return setSize(setDPR(getDPR(), isPortrait ? portraitURL : landscapeURL), measurement, dimension);
}
var ref;
var getMediaFromRef = function(target) {
    return (ref = target === null || target === void 0 ? void 0 : target.firstChild) !== null && ref !== void 0 ? ref : null;
};
// checks if the image has been already loaded by lcp-image-loader.js
var shouldImageBeLoaded = function(target) {
    var ref, ref1;
    return ((ref = getMediaFromRef(target)) === null || ref === void 0 ? void 0 : (ref1 = ref.dataset) === null || ref1 === void 0 ? void 0 : ref1.lcpLoaded) !== "true";
};
var getResolvedImgUrl = function(param) {
    var imageRef = param.imageRef, portraitURL = param.portraitURL, landscapeURL = param.landscapeURL, width = param.width, height = param.height, dimensionType = param.dimensionType;
    var ref;
    return shouldImageBeLoaded(imageRef.current) ? getUrl(portraitURL, landscapeURL, width, height, dimensionType === null || dimensionType === void 0 ? void 0 : dimensionType.isPortrait) : (ref = getMediaFromRef(imageRef.current)) === null || ref === void 0 ? void 0 : ref.src;
};


/***/ }),

/***/ 53788:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "BA": function() { return /* binding */ DESKTOP_LARGE; },
/* harmony export */   "Dv": function() { return /* binding */ DIMENSION_TYPES; },
/* harmony export */   "EV": function() { return /* binding */ TABLET; },
/* harmony export */   "Ib": function() { return /* binding */ getDimensionType; },
/* harmony export */   "JS": function() { return /* binding */ DESKTOP_WIDE; },
/* harmony export */   "Jq": function() { return /* binding */ MOBILE; },
/* harmony export */   "Kl": function() { return /* binding */ getElementBySelector; },
/* harmony export */   "Pg": function() { return /* binding */ getHeader; },
/* harmony export */   "jd": function() { return /* binding */ MEDIA_TABLET; },
/* harmony export */   "q5": function() { return /* binding */ DESKTOP; },
/* harmony export */   "x4": function() { return /* binding */ isPortraitView; }
/* harmony export */ });
/* unused harmony exports MEDIA_DESKTOP_WIDE, MEDIA_DESKTOP_LARGE, MEDIA_DESKTOP */
var DESKTOP = "desktop";
var DESKTOP_LARGE = "desktop-large";
var DESKTOP_WIDE = "desktop-wide";
var TABLET = "tablet";
var MOBILE = "mobile";
var DIMENSION_TYPES = {
    DESKTOP: DESKTOP,
    DESKTOP_LARGE: DESKTOP_LARGE,
    DESKTOP_WIDE: DESKTOP_WIDE,
    MOBILE: MOBILE,
    TABLET: TABLET
};
var MEDIA_DESKTOP_WIDE = 1920;
var MEDIA_DESKTOP_LARGE = 1440;
var MEDIA_DESKTOP = 960;
var MEDIA_TABLET = 600;
var getElementBySelector = function(selector) {
    return document.querySelector(selector);
};
var getHeader = function() {
    return getElementBySelector(".pre-l-header-container");
};
var getDimensionType = function() {
    if (false) {}
    if (window.matchMedia("(min-width: ".concat(MEDIA_DESKTOP_WIDE, "px)")).matches) return DESKTOP_WIDE;
    if (window.matchMedia("(min-width: ".concat(MEDIA_DESKTOP_LARGE, "px)")).matches) return DESKTOP_LARGE;
    if (window.matchMedia("(min-width: ".concat(MEDIA_DESKTOP, "px)")).matches) return DESKTOP;
    if (window.matchMedia("(min-width: ".concat(MEDIA_TABLET, "px) and (max-width: ").concat(MEDIA_DESKTOP - 1, "px)")).matches) return TABLET;
    if (window.matchMedia("(max-width: ".concat(MEDIA_TABLET - 1, "px)")).matches) return MOBILE;
    return TABLET;
};
var isPortraitView = function() {
    if (__webpack_require__.g.window && __webpack_require__.g.window.matchMedia) {
        return __webpack_require__.g.window.matchMedia("(max-width: ".concat(MEDIA_DESKTOP, "px) and (orientation:portrait)")).matches;
    }
    return true;
};


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [179], function() { return __webpack_exec__(20427); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);